module.exports = __webpack_public_path__ + "static/img/NavQRCode.a11ccd96.svg";